import { createFileRoute } from '@tanstack/react-router';
import CleaningMissionDetailsPage from '../../features/environmental-cleaning/pages/CleaningMissionDetailsPage';
import { getCleaningMissionQueryOptions } from '../../features/environmental-cleaning/queries';

export const Route = createFileRoute('/_auth/environmental-cleaning/missions/$id')({
  loader: ({ context, params }) => context.queryClient.ensureQueryData(getCleaningMissionQueryOptions(params.id)),
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <CleaningMissionDetailsPage missionId={id} />;
}
